<template>
  <asc-dialog
    class="asc-custom-alert-airline-report-type-choice-dialog"
    :show-dialog="showDialog"
    :text="title"
    :on-close="handleClose"
    full-width-buttons
    :width="500"
  >
    <template v-if="showDialog">
      <div class="asc-custom-alert-airline-report-type-choice">
        <asc-custom-alert-airline-report-type-choice
          v-model="currentData"
          :report-types="reportTypes"
          :airlines="airlines"
          :platforms="platforms"
          :information="subText"
          :show-airline="showAirline"
          :show-report-type="showReportType"
          :show-platform="showPlatform"
          :mapped-lu-master-models-all="mappedLuMasterModelsAll"
        ></asc-custom-alert-airline-report-type-choice>
        <v-card-actions>
          <v-row justify="space-between" no-gutters class="flex-shrink-0">
            <div class="ml-2 mt-2">
              <asc-link-button
                text="< Go Back"
                :uppercase="false"
                :hover="false"
                @click="onBackClick"
              ></asc-link-button>
            </div>
            <div class="mr-1">
              <asc-accent-button
                :disabled="isCurrentDataValid"
                :loading="false"
                :on-click="handleAccept"
                button-text="Next"
                :large="true"
              ></asc-accent-button>
            </div>
          </v-row>
        </v-card-actions>
      </div>
    </template>
  </asc-dialog>
</template>

<script>
import AscDialogMixin from '../mixins/AscDialogMixin.vue'
import AscDialog from '../atoms/AscDialog.vue'
import AscLinkButton from '../atoms/AscLinkButton.vue'
import AscAccentButton from '../atoms/AscAccentButton.vue'
import AscCustomAlertAirlineReportTypeChoice from '../molecules/AscCustomAlertAirlineReportTypeChoice.vue'

export default {
  name: 'AscCustomAlertAirlineReportTypeChoiceDialog',

  components: {
    AscDialog,
    AscCustomAlertAirlineReportTypeChoice,
    AscLinkButton,
    AscAccentButton,
  },
  mixins: [AscDialogMixin],

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    reportTypes: {
      type: Array,
      default: () => [],
    },
    airlines: {
      type: Array,
      default: () => [],
    },
    platforms: {
      type: Array,
      default: () => [],
    },
    mappedLuMasterModelsAll: {
      type: Array,
      default: () => [],
    },
    showAirline: {
      type: Boolean,
      default: false,
    },
    showReportType: {
      type: Boolean,
      default: false,
    },
    showPlatform: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subText: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      currentData: this.data,
    }
  },

  computed: {
    isCurrentDataValid() {
      // Airline Choice Select Only
      if (this.showAirline && !this.showReportType && !this.showPlatform) {
        if (!this.currentData) {
          return true
        }
        if (
          this.currentData.airlineSelect === null ||
          this.currentData.airlineSelect === ''
        ) {
          return true
        }
        return false
      }
      // Platform Choice Select Only
      if (!this.showAirline && !this.showReportType && this.showPlatform) {
        if (!this.currentData) {
          return true
        }
        if (
          this.currentData.platformSelect === null ||
          this.currentData.platformSelect === ''
        ) {
          return true
        }
        return false
      }
      // Platform & Report Type Choice Select Only
      if (!this.showAirline && this.showReportType && this.showPlatform) {
        if (!this.currentData) {
          return true
        }
        if (
          this.currentData.platformSelect === null ||
          this.currentData.platformSelect === '' ||
          this.currentData.reportType === null ||
          this.currentData.reportType === ''
        ) {
          return true
        }
        return false
      } else if (
        // Airline and Platform
        this.showAirline &&
        !this.showReportType &&
        this.showPlatform
      ) {
        if (!this.currentData) {
          return true
        }
        if (
          this.currentData.airlineSelect === null ||
          this.currentData.airlineSelect === ''
        ) {
          return true
        }
        if (
          this.currentData.platformSelect === null ||
          this.currentData.platformSelect === ''
        ) {
          return true
        }
        return false
      } else if (
        // Airline and Report Type
        this.showAirline &&
        this.showReportType &&
        !this.showPlatform
      ) {
        if (!this.currentData) {
          return true
        }
        if (
          this.currentData.airlineSelect === null ||
          this.currentData.airlineSelect === ''
        ) {
          return true
        }
        if (
          this.currentData.reportType === null ||
          this.currentData.reportType === ''
        ) {
          return true
        }
        return false
      } else {
        // Airline, Platform, and Report Type

        if (!this.currentData) {
          return true
        }
        if (
          this.currentData.reportType === null ||
          this.currentData.reportType === ''
        ) {
          return true
        }
        if (
          this.currentData.airlineSelect === null ||
          this.currentData.airlineSelect === ''
        ) {
          return true
        }
        if (
          this.currentData.platformSelect === null ||
          this.currentData.platformSelect === ''
        ) {
          return true
        }
        return false
      }
    },
  },

  watch: {
    data: {
      handler(newVal) {
        this.currentData = newVal
      },
    },
  },

  methods: {
    handleAccept() {
      this.onAccept(this.currentData)
      this.handleClose()
      this.currentData = null
    },
    onBackClick() {
      this.currentData = null
      this.$emit('onBackClick')
    },
    handleClose() {
      this.currentData = null
      this.$emit('onClose')
    },
  },
}
</script>

<style lang="scss">
.asc-custom-alert-airline-report-type-choice-dialog--container {
  & .asc-empty-div {
    height: 30px;
  }

  .asc-dialog {
    .v-card {
      &__title {
        padding-bottom: 0 !important;
        height: 0;

        .asc-close-button {
          right: -2px;
          top: -3px;

          .v-icon {
            color: $primary-black !important;
            font-weight: bold;
          }
        }
      }

      &__text {
        padding-bottom: 16px !important;

        .asc-custom-alert-airline-report-type-choice {
          &--header {
            margin-bottom: 35px;
            padding: 8px 25px 0 8px;
          }

          &--options {
            .asc-selection--option {
              background-color: $gray-200;
              margin-bottom: 1px;
              padding: 20px 16px 18px 16px;

              .asc-label.description {
                margin: 14px 0 0 0;
                line-height: 18px;
                display: block;
                text-align: center;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
